import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
}

// Conteneur du site : 1440 px maximum, gouttières 20 / 32 px.
export const Container: FC<ContainerProps> = ({ children, className }): ReactNode => {
    return (
        <div className={cn('mx-auto w-full max-w-site px-5 sm:px-8', className)}>
            {children}
        </div>
    )
}
